import { defineMessages } from 'react-intl';

export default defineMessages({
  // These keys match with the keys defined in SearchException.ErrorKey in the
  // bitbucket-search project.
  QUERY_EXPRESSION_LIMIT: {
    id: 'frontbucket.search.errors.queryExpressionLimit',
    description: 'The error shown when a search query has too many expressions',
    defaultMessage: 'Try modifying your query - you can use up to 10 operators',
  },
  QUERY_LENGTH_LIMIT: {
    id: 'frontbucket.search.errors.queryLengthLimit',
    description: 'The error shown when a search query is too long',
    defaultMessage:
      'Try modifying your query - you can use up to 250 characters.',
  },
  QUERY_WITHOUT_POSITIVE_TERMS: {
    id: 'frontbucket.search.errors.queryWithoutPositiveTerms',
    description:
      'The error shown when a search query was entered that does not contain any positive search terms (only negative ones)',
    defaultMessage:
      'Your query contains exclusive search operators (- or NOT) but no search term.\nAdd a search term to your query and try again.',
  },
  QUERY_WITHOUT_TERMS: {
    id: 'frontbucket.search.errors.queryWithoutTerms',
    description:
      'The error shown when a search query was entered that does not contain any search terms (only modifiers)',
    defaultMessage: 'Add a search term to your query and try again.',
  },
});
